var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email",
    transform: "translate(-828 -528)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5338",
    "data-name": "Group 5338"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 128,
    height: 128,
    transform: "translate(828 528)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "envelope",
    d: "M113.653,59.882H11.757A11.77,11.77,0,0,0,0,71.639v70.543A11.77,11.77,0,0,0,11.757,153.94h101.9a11.77,11.77,0,0,0,11.757-11.757V71.639A11.77,11.77,0,0,0,113.653,59.882Zm0,7.838a3.9,3.9,0,0,1,1.5.3l-52.45,45.459L10.255,68.024a3.9,3.9,0,0,1,1.5-.3Zm0,78.382H11.757a3.922,3.922,0,0,1-3.919-3.919V76.3l52.3,45.326a3.925,3.925,0,0,0,5.136,0l52.3-45.326v65.878A3.922,3.922,0,0,1,113.653,146.1Z",
    transform: "translate(829.295 485.089)",
    fill: "#98235c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.bf7c9297.svg";
export { ForwardRef as ReactComponent };